import { ACTIONS } from 'actions/accessibility'

export const initialState = {
    announcerMessage: '',
}

export default (state = initialState, action) => {
    switch (action.type) {
    case ACTIONS.SET_ANNOUNCER:
        return {
            ...state,
            announcerMessage: action.data,
        }
    default:
        return state
    }
}
